import React, { useMemo } from "react";
import { graphql, useFragment } from "react-relay";
import {
  AHImageHorizontalCollectionItem,
  AHImageHorizontalCollectionStaticSize,
} from "../../../components";
import { DescriptionContentMedia_Media$key } from "./__generated__/DescriptionContentMedia_Media.graphql";
import { useLightboxControls } from "@/src/common/lightbox/LightboxProvider";

export function DescriptionContentMedia(props: {
  media: DescriptionContentMedia_Media$key;
}) {
  const _media = useFragment(
    graphql`
      fragment DescriptionContentMedia_Media on Image @relay(plural: true) {
        id
        sizes {
          height
          width
        }
        ...Image_image
        __typename
      }
    `,
    props.media
  );

  const media = useMemo(
    () =>
      _media.map((item) => {
        return {
          id: item.id,
          type: "image" as const,
          image: { image: item, type: "remote" as const },
        };
      }),
    [_media]
  );

  const lightbox = useLightboxControls();

  const showMedia = useMemo(() => media.length > 0, [media.length]);

  return showMedia ? (
    <>
      <AHImageHorizontalCollectionStaticSize space="medium" size={100}>
        {media.map((item, i) => {
          return (
            <AHImageHorizontalCollectionItem
              key={item.id}
              image={item.image.image}
              type="remote"
              onPress={() => {
                lightbox.openLightbox({
                  index: i,
                  images: media.map((m) => ({
                    image: {
                      image: m.image.image,
                      type: "remote" as const,
                    },
                    dimensions: {
                      width: item.image.image.sizes[0]?.width ?? 1,
                      height: item.image.image.sizes[0]?.height ?? 1,
                    },

                    mediaType: "image" as const,
                  })),
                });
              }}
            />
          );
        })}
      </AHImageHorizontalCollectionStaticSize>
    </>
  ) : null;
}
